export const getPartnerColor = (partner) => {
  switch (partner) {
    case 'Zong':
      return 'rgba(239, 68, 68, 0.85)';
    // return "rgba(135, 182, 40, 0.85)" // Red
    case 'Telenor':
      return 'rgba(59, 130, 246, 0.85)'; // Green
    case 'Jazz':
      return 'rgba(34, 197, 94, 0.85)'; // Blue
    case 'zong':
      return 'rgba(251, 191, 36, 0.85)';
    case 'cybernet':
      return 'rgba(78, 158, 215, 0.85)';
    case 'wateen':
      return 'rgba(28, 96, 119, 0.85)';
    case 'multinet':
      return 'rgba(245, 214, 14, 0.85)';
    case 'optix':
      return 'rgba(248, 26, 185, 0.85)';
    case 'ptcl':
      return 'rgba(46, 118, 12, 0.85)';
    case 'ufone':
      return 'rgba(218, 85, 14, 0.85)';
    case 'jazz':
      return 'rgba(238, 26, 26, 0.85)';
    case 'telenor':
      return 'rgba(180, 32, 225, 0.85)';
    case 'nayatel':
      return 'rgba(225, 141, 32, 0.85)';

    default:
      return 'rgba(156, 163, 175, 0.85)'; // Gray (fallback)
  }
};
